import { ResourceInfoDc } from "@evergis/api";

import { usePostgresLayerWithTable } from "../../../../../../hooks/layer/usePostgresLayerWithTable";
import { useLayerPreview } from "../../../../../../hooks/preview/usePreview";
import { getMetaFromResource, useResourceMeta } from "../../../../../../hooks/useResourceMeta";

import { LayerInfo } from "../../../../../../interfaces/resourceInfo";

export const useLayerDetails = (layerInfo: LayerInfo) => {
  const {
    layer: { geometryType },
  } = usePostgresLayerWithTable(layerInfo?.name, true);

  const [previewUrl] = useLayerPreview(layerInfo?.name);
  const [meta] = useResourceMeta(getMetaFromResource(layerInfo as ResourceInfoDc, previewUrl));

  return {
    name: layerInfo?.name,
    meta,
    previewUrl,
    geometryType,
  };
};
